/**
 * Per-browser values in localStorage that the UI can subscribe to (see hooks/use-local-value.ts).
 * Best effort: storage can be unavailable (private mode, blocked site data), in which case reads
 * return null and writes are dropped. Other tabs see changes through the `storage` event.
 */
const CHANGE_EVENT = "qpp:local-store";

export function readLocal(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

/** Stores `value` (or removes the key for null) and tells subscribers. */
export function writeLocal(key: string, value: string | null): void {
  try {
    if (value === null) localStorage.removeItem(key);
    else localStorage.setItem(key, value);
  } catch {
    // Not persisted; subscribers still re-read below.
  }
  window.dispatchEvent(new Event(CHANGE_EVENT));
}

export function subscribeLocal(onChange: () => void): () => void {
  window.addEventListener(CHANGE_EVENT, onChange);
  window.addEventListener("storage", onChange);
  return () => {
    window.removeEventListener(CHANGE_EVENT, onChange);
    window.removeEventListener("storage", onChange);
  };
}
